import { render } from "./CaseDetail.vue?vue&type=template&id=3e563ade"
import script from "./CaseDetail.vue?vue&type=script&lang=js"
export * from "./CaseDetail.vue?vue&type=script&lang=js"

import "./CaseDetail.vue?vue&type=style&index=0&id=3e563ade&lang=css"

import exportComponent from "E:\\wamp64\\www\\law-firm-system-vue\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__